export const passwordPattern = '((?=.{8,})(?=.*[A-Z]))';

export const namePattern = /^[A-Za-z\s]+$/;
